import { connect } from 'react-redux';
import { getCard } from '../reducer/card/selectors';
import { getCustomerCard } from '../../customer/selectors';
import CardChargeButton from '../components/CardChargeButton';
import { openCardPayment } from '../reducer/currentPayment/actions';
import { getIsFetching } from '../reducer/isFetching/selectors';
import { getHasCardPayment } from '../reducer/payments/selectors';
import { getHasPaymentOpened } from '../reducer/currentPayment/selectors';

const CardChargeButtonContainer = connect(
  state => ({
    disabled: getIsFetching(state) || getHasPaymentOpened(state) || getHasCardPayment(state),
    card: getCustomerCard(state) || getCard(state),
  }),
  { open: openCardPayment }
)(CardChargeButton);

export default CardChargeButtonContainer;
